import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs'
import { encrypt, decrypt } from '@/utils/des.js' 

// Set config defaults when creating the instance
const instance = axios.create({
    // baseURL: 'http://doc.qiyunku.com:8000/prod-api',
    // baseURL: 'https://doc.qiyunku.com/prod-api',
    baseURL: 'https://docx.qiyunku.com/prod-api',    // 正式
    timeout: 10000
});

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    config.headers = {
        "content-type": "application/json",
        "X-WX-Token": localStorage.getItem('token')
    }

    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    const str = response.config.url.slice(0, 23)
    if (str != 'https://view.xdocin.com' && str != 'qyk/oss/upload') {
        const code = JSON.parse(decrypt(response.data)).code;
        if (code == 500) {
            localStorage.removeItem('phone')
            localStorage.removeItem('token')
        }
    }
    
    // if (code == 404 || code == 500) {
    //     localStorage.removeItem('phone')
    //     localStorage.removeItem('token')
    //     this.$router.push({path: '/home'})
    // }
    // 对响应数据做点什么
    return response.data;
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

export default instance


// WEBPACK FOOTER //
// ./src/utils/http.js